export const links = [
  {
    to: "/",
    name: "главная",
    title: "на главную",
  },
  {
    to: "/about",
    name: "обо мне",
    title: "обо мне",
  },
  {
    to: "/photos",
    name: "фото",
    title: "фото",
  },
  {
    to: "/videos",
    name: "видео",
    title: "видео",
  },
  {
    to: "/cooperation",
    name: "договор",
    title: "как я работаю",
  },

  {
    to: "/contacts",
    name: "контакты",
    title: "контакты",
  },
]
